// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
    /* tslint:disable */
    export const VERSION = {
    "dirty": false,
    "raw": "ec50503",
    "hash": "ec50503",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "ec50503",
    "semverString": null,
    "version": "0.15.4",
    "buildtime": "2026-04-13T11:24:33.965Z",
    "branch": "hps_merge_tmp"
};
    /* tslint:enable */
    